import { css } from 'styled-components';

export const VideoPlayerWrapper = css`
  max-width: 720px;
  height: auto;
  margin: 0 auto;
`;

export const VideoPlayer = css`
  position: relative;
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0 0 56.25% 0;
  cursor: pointer;
  border: 0 none;
`;

export const YoutubeIframe = css`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const VideoThumbnail = css`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
